var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"head-img"},[_c('img',{attrs:{"src":require("../../assets/img/theBrainProject/bgc.png")}})])])
}]

export { render, staticRenderFns }